import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { Nomination, NominationAssignment } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import _ from 'lodash';
import { xor } from 'lodash';
import { NominationSettingDialogComponent } from '../nomination-setting-dialog/nomination-setting-dialog.component';

@Component({
    selector: 'app-nomination-overview',
    templateUrl: './nomination-overview.component.html',
    styleUrls: ['./nomination-overview.component.scss'],
    standalone: false,
})
export class NominationOverviewComponent implements OnInit {
    nomination: any = {};
    nominations: any;
    people: any[];
    roles = ['Deacon', 'Shepherding Elder', 'Executive Elder'];
    nominationGroups: any;
    assignment: any = {};
    assignments: NominationAssignment[];
    showJoinedDate = false;
    showEntryPanel = true;
    showGroupingPanel = true;
    showAssignmentsPanel = true;

    @ViewChild('nominationGrid') nominationGrid: DxDataGridComponent;
    @ViewChild('groupGrid') groupGrid: DxDataGridComponent;
    @ViewChild('assignmentGrid') assignmentGrid: DxDataGridComponent;

    selectedMonthId: number;
    givingTypes: any[];
    types: any[];
    otherAccounts: any[];

    specialAccountId: number;
    batchId: number;
    saveEnable = true;
    addProcessing = false;
    processing = false;
    bankAmounts: any[];
    bankEntry: any;
    fee = 0.0;
    cloverTotal = 0.0;
    previousBatches: any;
    previousBatch: any;
    nextMonthTotal = 0.0;
    yearValue: any;
    isAdmin = false;

    @ViewChild('personSelect') personSelect: any;
    @ViewChild('bankSelect') bankSelect: any;
    @ViewChild('nextGrid') nextGrid: DxDataGridComponent;
    @ViewChild('bankGrid') bankGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        public auth: AuthService,
        private utility: UtilityService,
        private modalService: BsModalService,
    ) {}

    async ngOnInit() {
        // this.nomination = this.uow.nominations.createEntity();

        await this.getData();
        await this.getGroupedData();
        await this.getAssignments();
        this.people = await this.uow.getPeopleForNominations();
        this.isAdmin = this.auth.hasRole('Nominations:Admin');
    }

    async ngOnDestroy() {
        this.uow.rollback();
    }

    async getData() {
        this.nominations = await this.uow.getNominations();
    }

    async getGroupedData() {
        this.nominationGroups = await this.uow.getNominationGroups();
        let i = 0;
        this.nominationGroups.forEach((x) => {
            x.id = i;
            x.joined = x.joinedDate ? moment(x.joinedDate).toDate() : null;
            i++;
        });
    }
    async getAssignments() {
        this.assignments = (await this.uow.getNominationConfirmed()) as NominationAssignment[];
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
        );
    }

    onSelectionChange(e) {
        if (e.rowType === 'data') {
            if (!!e.data.currentMonth) {
                e.rowElement.className = e.rowElement.className + ' currentMonth-grid ';
            }
            if (!!e.data.nextMonth) {
                e.rowElement.className = e.rowElement.className + ' nextMonth-grid ';
            }
        }
    }

    onRowPrepare(e) {
        if (e.rowType === 'data') {
            // console.log(e);
            if (e.data.joined && this.showJoinedDate && e.data.joined > moment(new Date()).add(-1, 'years')) {
                e.cells.forEach((cell) => {
                    if (cell.column.dataField === 'joined') {
                        cell.cellElement.className = cell.cellElement.className + ' joined-recent';
                    }
                });
            }
        }
    }

    async add() {
        this.addProcessing = true;
        const previousRole = this.nomination.role;
        this.nomination.created = new Date();
        this.nomination.createdBy = this.auth.currentUser.userName;

        this.uow.nominations.createEntity({
            personId: this.nomination.personId,
            role: this.nomination.role,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        });

        await this.uow.commit();

        this.nomination.personId = null;
        this.nomination.role = previousRole;
        this.addProcessing = false;
        await this.getData();

        setTimeout(() => {
            this.personSelect.instance.focus();
        });
    }
    async deleteNomination() {
        const selectedRow = this.nominationGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        selectedRow.entityAspect.setDeleted();
        await this.uow.commit([selectedRow]);
        await this.getData();

        this.nomination = this.uow.nominations.createEntity();
    }

    async confirm() {
        // if (!this.nomination.entityAspect.entityState.isDetached()) this.nomination.entityAspect.rejectChanges();
        const selectedRows = this.groupGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        const rows = selectedRows;
        this.appInfo.pleaseWaitShow();

        for (let index = 0; index < selectedRows.length; index++) {
            const row = selectedRows[index];
            const assignment = this.uow.nominationAssignments.createEntity({
                personId: row.personId,
                role: this.assignment.role,
                created: new Date(),
                confirmed: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }
        await this.uow.commit();
        await this.getData();
        await this.getAssignments();
        this.groupGrid.instance.clearSelection();
        // this.assignment.role = null;
        this.appInfo.pleaseWaitHide();
    }

    async markAssignment(mode: string) {
        // if (!this.nomination.entityAspect.entityState.isDetached()) this.nomination.entityAspect.rejectChanges();
        const selectedRows = this.assignmentGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        const rows = selectedRows;
        this.appInfo.pleaseWaitShow();

        for (let index = 0; index < selectedRows.length; index++) {
            const row = selectedRows[index];

            // selectedRows.forEach((row) => {
            if (mode === 'Accept') row.accepted = new Date();
            if (mode === 'Decline') {
                this.appInfo.pleaseWaitHide();
                const result = await this.getInput('Enter Reason', 'textarea', null, null);
                if (result) {
                    console.log(result);
                    row.note = result;
                }
                row.declined = new Date();
                this.appInfo.pleaseWaitShow();
            }
            if (mode === 'Delete') row.deleted = new Date();
            if (mode === 'Clear') {
                row.accepted = null;
                row.declined = null;
                row.note = null;
            }
            // });
        }

        await this.uow.commit();
        await this.getAssignments();
        this.assignmentGrid.instance.clearSelection();
        this.appInfo.pleaseWaitHide();
    }

    async getReason() {}

    async printNominationForm() {
        const roughDate = moment({ year: new Date().getFullYear(), month: 1, day: 12 }).toDate();
        const dueDate = await this.getInput('Select Due Date', 'date', null, roughDate);
        if (!dueDate) return;
        const result = await this.utility.printNomination(dueDate);
    }

    async getInput(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }

    async closeAll() {
        const result = await confirm(`Are you sure you want to CLOSED all nominations?`, `${this.appInfo.settings.church}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        this.uow.rollback();
        this.nominations.forEach((x) => {
            x.closed = new Date();
        });
        this.assignments.forEach((x) => {
            x.closed = new Date();
        });

        await this.uow.commit();
        await this.getData();
        await this.getGroupedData();
        await this.getAssignments();
        this.appInfo.pleaseWaitHide();
    }

    async getNominationEndDate(message?: string): Promise<Date> {
        let endDate = new Date(new Date().getFullYear(), 0, 31); //jan 31 for starters
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'GRAAFSCHAP',
                dialogPrompt: message ? message : `Enter Due Date for Nominations`,
                dialogValue: endDate,
                mode: 'date',
            },
        });

        const promise = new Promise<Date>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    endDate = moment(result.value).startOf('day').toDate();
                }
                modalRef.hide();
                resolve(result.value);
            });
        });
        return promise;
    }

    async createVotes() {
        const voteCheck = await this.uow.createNominationCheck();
        if (voteCheck) {
            await alert(`Nomination Votes have already been created for this year.`, `${this.appInfo.settings.church}`);
            return;
        }

        const result = await confirm(`Are you sure you want to create all nomination votes?`, `${this.appInfo.settings.church}`);
        if (!result) return;

        const endDate = await this.getNominationEndDate();
        if (!endDate) return;

        this.appInfo.pleaseWaitShow();
        await this.utility.createNominationVotes(endDate);
        this.appInfo.pleaseWaitHide();
        await alert(`Done!`, `${this.appInfo.settings.church}`);
    }

    async emailVotes() {
        this.appInfo.pleaseWaitShow();
        const nominationVotes = await this.uow.getNominationVotes();
        this.appInfo.pleaseWaitHide();
        
        const result = await confirm(`Are you sure you want to Email all nomination votes? Count: ${nominationVotes.length}`, `${this.appInfo.settings.church}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        await this.utility.emailNominations();
        this.appInfo.pleaseWaitHide();
    }

    async printVoteReport() {
        await this.utility.printNominationBallot();
    }

    async printNominationFormReport() {
        const endDate = await this.getNominationEndDate('Enter due date');
        if (!endDate) return;
        await this.utility.printNominationForm(endDate);
    }

    async nominationInfo() {
        const setting = (await this.uow.getSettingsByName('NominationRules')) as any;
        const message = String(setting.stringValue).replace(RegExp('-', 'g'), '<br>');
        await alert(`${message}`, `${this.appInfo.settings.church.toUpperCase()}`);
    }

    async settings() {
        const modalRef = this.modalService.show(NominationSettingDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {},
        });

        modalRef.content.result.subscribe((result) => {
            modalRef.hide();
        });
    }
}
class NominationItem {
    id: number;
    personName: string;
    personId: number;
    role: string;
    constructor() {}
}
